import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
`;

export const Label = styled.div`
	font-weight: 400;
	font-size: 13px;
	line-height: 16px;
	color: ${colors.grey5};
	padding-left: 16px;
	padding-right: 4px;

	&:first-child {
		padding-left: 0;
	}
`;

export const SheetTooltip = styled.p`
	text-align: left;
	font-size: 12px;
	padding: 2px;
`;

export const BoldText = styled.span`
	font-weight: 500;
`;
